import { ref, watch } from 'vue'
import type { ICartLocalStorage, ICartStore } from '@/composables/Interfaces/appInterfaces'
import { useCartAccosApi } from '@/composables/useApi'
import { CartLocalStorage } from '@/constants'
import type { IAccoItem } from '@/composables/Interfaces/apiInterfaces'
import { broadcastChannelMessages } from '@/composables/helpers'
import { watchIgnorable } from '@vueuse/core'

export const cartStore = ref<ICartStore>({
  accos: []
})

export const enquiryBoxVisible = ref(false)

export const broadcasterCartStore = new BroadcastChannel(CartLocalStorage)
export const messageReceiverCartStore = new BroadcastChannel(CartLocalStorage)

function emitToOtherApps() {
  broadcasterCartStore.postMessage(broadcastChannelMessages.UPDATE)
}

messageReceiverCartStore.addEventListener('message', async (e) => {
  switch (e.data) {
    case broadcastChannelMessages.UPDATE:
      await initCartStoreFromLocalStorage()
      break
    default:
      console.warn(`NO HANDLER FOR MESSAGE: ${e.data}`)
  }
})

const watchCartStore = watchIgnorable(
  cartStore.value,
  () => {
    setCartStoreLocalStorage()
    emitToOtherApps()
  },
  { deep: true }
)

function setCartStoreLocalStorage(): void {
  const cartCids = cartStore.value.accos.map((x) => x.companyId)
  localStorage.setItem(CartLocalStorage, JSON.stringify({ cids: cartCids })) // we want to save only the cids in the local storage
}

export async function initCartStoreFromLocalStorage(): Promise<void> {
  const localCartStorage = localStorage.getItem(CartLocalStorage)
  if (localCartStorage != null) {
    const localStorage: ICartLocalStorage = JSON.parse(localCartStorage)
    const accos: ICartStore = await useCartAccosApi(localStorage.cids)
    //ignoreUpdates otherwise endless loop if two apps are on the same page
    watchCartStore.ignoreUpdates(() => {
      cartStore.value.accos = accos.accos
    })
  }
}

export async function addCidToCartLocalStorage(cid: number) {
  const acco: ICartStore = await useCartAccosApi([cid])
  cartStore.value.accos.push(acco.accos[0])
}

export function removeCidFromCartLocalStorage(cid: number) {
  const index = cartStore.value.accos.findIndex((x: IAccoItem) => x.companyId === cid)
  if (index > -1) {
    cartStore.value.accos.splice(index, 1)
  }
}

export function clearCart() {
  cartStore.value.accos = []
}

let enquiryBoxTimeout: any = null
export function showAndHideEnquiryBox() {
  enquiryBoxVisible.value = true

  if (enquiryBoxTimeout) {
    clearTimeout(enquiryBoxTimeout)
  }

  enquiryBoxTimeout = setTimeout(() => {
    enquiryBoxVisible.value = false
    enquiryBoxTimeout = null
  }, 3000)
}
